export default "__VITE_ASSET__0b3c33e4__"